import {
  IAction,
  IBooleanValueAction,
  IStringValueAction
} from "../../../redux/actions";

export interface IGameSetting {
  key: string;
  value: any;
}

export interface IGameSettingsValueAction extends IAction {
  value: IGameSetting;
}

export enum types {
  SET_GAME_RULES_CONTENT = "SET_GAME_RULES_CONTENT",
  SET_GAME_RULES_AVAILABLE = "SET_GAME_RULES_AVAILABLE",
  SET_GAME_HISTORY_ENABLED = "SET_GAME_HISTORY_ENABLED",
  SET_GAME_HISTORY_AVAILABLE = "SET_GAME_HISTORY_AVAILABLE",
  TRIGGER_SETTING_CHANGE_REQUEST = "TRIGGER_SETTING_CHANGE_REQUEST"
}

export const setGameRulesContent = (value: string): IStringValueAction => {
  return {
    type: types.SET_GAME_RULES_CONTENT,
    value
  };
};

export const setGameRulesAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_GAME_RULES_AVAILABLE,
    value
  };
};

export const setGameHistoryAvailable = (
  value: boolean
): IBooleanValueAction => {
  return {
    type: types.SET_GAME_HISTORY_AVAILABLE,
    value
  };
};

export const setGameHistoryEnabled = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_GAME_HISTORY_ENABLED,
    value
  };
};

export const triggerSettingChangeRequest = (
  value: IGameSetting
): IGameSettingsValueAction => {
  return {
    type: types.TRIGGER_SETTING_CHANGE_REQUEST,
    value
  };
};
